import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Phone, MessageCircle, Sparkles } from 'lucide-react';
import { mockData } from '../../data/mock';
import { Reveal } from './Reveal';

export const FinalCta = () => (
  <section className="py-24 bg-primary-blue text-white relative overflow-hidden">
    <Sparkles className="absolute -top-10 -left-10 w-64 h-64 text-white/5" />
    <div className="max-w-4xl mx-auto px-4 text-center relative">
      <Reveal>
        <h2 className="font-heading text-3xl md:text-5xl font-light mb-6">Parlons de votre projet</h2>
        <p className="text-xl text-white/70 mb-10 max-w-2xl mx-auto">
          Un premier échange gratuit pour comprendre vos besoins et vous proposer un accompagnement sur-mesure.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild className="bg-warm-accent hover:bg-white hover:text-primary-blue text-white rounded-full px-8 py-6 text-base font-medium">
            <Link to="/contact" data-testid="final-cta-contact" className="flex items-center gap-2">
              <Phone className="w-5 h-5" />
              Prendre rendez-vous
            </Link>
          </Button>
          <Button asChild variant="outline" className="border-white/40 text-white hover:bg-white hover:text-primary-blue rounded-full px-8 py-6 text-base font-medium bg-transparent">
            <a href={`https://wa.me/${mockData.cabinet.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp" className="flex items-center gap-2">
              <MessageCircle className="w-5 h-5" />
              WhatsApp
            </a>
          </Button>
        </div>
      </Reveal>
    </div>
  </section>
);
